import React, { Fragment } from 'react';
import * as Yup from 'yup';

import { Formik } from 'formik';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';


import {
    makeStyles,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Document = ({ item, open, closeEdition, updateValues, selectedMode }) => {

    const classes = useStyles();

    const fileSize = (bytes) => {
        var exp = Math.log(bytes) / Math.log(1024) | 0;
        var result = (bytes / Math.pow(1024, exp)).toFixed(2);
        return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
    }

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="sm" className={classes.root}>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Documento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                nome: Yup.string().max(255).required('Nome do arquivo é obrigatório'),
                                tamanho: Yup.number().required('Tamanho do arquivo é obrigatório'),
                                formato: Yup.string().required('Tipo do arquivo é obrigatório'),
                                descricao: Yup.string().max(255).required('Descrição do documento é obrigatório'),
                                tipo: Yup.string().required('Tipo de documento é obrigatório'),
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Box mt={1}>
                                    <Grid
                                        container
                                        spacing={2}
                                    >

                                        <Grid
                                            item
                                            md={7}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin='none' >
                                                <InputLabel shrink htmlFor="tipo" required >Tipo de Documento</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.tipo && errors.tipo)}
                                                    helperText={touched.tipo && errors.tipo}
                                                    value={values.tipo}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Localização do Sintoma *"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'tipo',
                                                        id: 'tipo',
                                                    }}
                                                >
                                                    <MenuItem value='' key='' >
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    <MenuItem value="ARTIE">
                                                        <em>ART de Iluminação de Emergencia</em>
                                                    </MenuItem>
                                                    <MenuItem value="ARTE">
                                                        <em>ART Elétrica</em>
                                                    </MenuItem>
                                                    <MenuItem value="ARTH">
                                                        <em>ART Hidraulica</em>
                                                    </MenuItem>
                                                    <MenuItem value="Foto">
                                                        <em>Foto</em>
                                                    </MenuItem>
                                                    <MenuItem value="Imagem">
                                                        <em>Imagem</em>
                                                    </MenuItem>
                                                    <MenuItem value="LE">
                                                        <em>Laudo de Elétrica</em>
                                                    </MenuItem>
                                                    <MenuItem value="LH">
                                                        <em>Laudo de Hidraulica</em>
                                                    </MenuItem>
                                                    <MenuItem value="LIE">
                                                        <em>Laudo de Iluminação de Emergência</em>
                                                    </MenuItem>
                                                    <MenuItem value="LSPDA">
                                                        <em>Laudo de SPDA</em>
                                                    </MenuItem>
                                                    <MenuItem value="Outros">
                                                        <em>Outros</em>
                                                    </MenuItem>


                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={5}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                cancelLabel="Cancelar"
                                                inputVariant="outlined"
                                                margin="none"
                                                readOnly
                                                id="date-picker-dialog1"
                                                label="Data de Envio"
                                                format="DD/MM/YYYY"
                                                name="dataEnvio"
                                                onChange={value => setFieldValue("dataEnvio", value)}
                                                value={values.dataEnvio}
                                                onBlur={handleBlur}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ readOnly: true, }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.descricao && errors.descricao)}
                                                fullWidth
                                                helperText="Coloque aqui a descrição do Documento e outros detalhes (250 caracteres)."
                                                label="Descrição do Documento"
                                                rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 5 : 3}
                                                multiline
                                                margin="none"
                                                name="descricao"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.descricao}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.nome && errors.nome)}
                                                fullWidth
                                                label="Nome do arquivo"
                                                rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                margin="none"
                                                name="nome"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.nome + ' (' + fileSize(values.tamanho) + ')'}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ readOnly: true, }}
                                            />

                                        </Grid>



                                    </Grid>

                                </Box>

                                <br></br>
                                <Divider />
                                <br></br>

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={2}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Document;
